/*************************************************************************
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

class CommonAppStore {
  getPageZoomLevel; // function getter to get pagezommlevel
  getNumPages; // function getter to get number of pages
  getPageTransformMatrix; // function getter to get tmatrix
  getViewRotationMatrix; // function getter to get view rotation matrix

  constructor() {
    this.init({});
  }

  init({
    getPageZoomLevel,
    getNumPages,
    getPageTransformMatrix,
    getViewRotationMatrix
  }) {
    this.setGetterForPageZoomLevel(getPageZoomLevel);
    this.setGetterForNumPages(getNumPages);
    this.setGetterForTransformMatrix(getPageTransformMatrix);
    this.setGetterForViewRotationMatrix(getViewRotationMatrix);
  }

  setGetterForPageZoomLevel(getPageZoomLevel) {
    this.getPageZoomLevel = getPageZoomLevel;
  }

  setGetterForNumPages(getNumPages) {
    this.getNumPages = getNumPages;
  }
  setGetterForTransformMatrix(getPageTransformMatrix) {
    this.getPageTransformMatrix = getPageTransformMatrix;
  }

  setGetterForViewRotationMatrix(getViewRotationMatrix) {
    this.getViewRotationMatrix = getViewRotationMatrix;
  }
}

export default CommonAppStore;
